export default __webpack_public_path__ + "atomic/_patterns/03-organisms/video-slideshow/_video-slideshow.twig";